import type { SuggestionKeyDownProps, SuggestionProps } from '@tiptap/suggestion';

import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './variablesList.less';
import VariableSearchPanel from 'components/editor/variables/VariableSearchPanel';
import type { VariableEntity } from 'services/entities/VariablesEntity';

export type VariablesListRef = {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean;
};

export const VariablesList = forwardRef<VariablesListRef, SuggestionProps<VariableEntity>>(function VariablesList(props, ref) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: number) => {
    const item = props.items[index];

    if (item) {
      props.command(item);
    }
  };

  const upHandler = () => {
    if (props.items.length === 0) return;

    const newIndex = (selectedIndex + props.items.length - 1) % props.items.length;

    setSelectedIndex(newIndex);
  };

  const downHandler = () => {
    if (props.items.length === 0) return;

    const newIndex = (selectedIndex + 1) % props.items.length;

    setSelectedIndex(newIndex);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      let handled = false;

      if (event.key === 'ArrowUp') {
        upHandler();
        handled = true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        handled = true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        handled = true;
      }

      return handled;
    },
  }));

  return <VariableSearchPanel isEditor query={props.query} />;
});
